export default __webpack_public_path__ + "static/media/AfricanFarmer.75be91c9.svg";